export function remove() {
  localStorage.removeItem('commodity/list/data');
  localStorage.removeItem('commodity/list/brandShowAll');
  localStorage.removeItem('commodity/list/showAll');
}